import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

const routerOptions = [
  { path: '/', component: 'Starting' },
  { path: '/login', component: 'Login' },
  { path: '/signup', component: 'SignUp' },
  { path: '/passwordreset', component: 'PasswordReset' },
  { path: '/adatkezeles', component: 'Privacy' },
  { path: '/home', component: 'Home', meta: { requiresAuth: true } },
  { path: '/group', component: 'Group', meta: { requiresAuth: true } },
  { path: '/profile', component: 'Profile', meta: { requiresAuth: true } },
  { path: '/expensesettings', component: 'ExpenseSettings', meta: { requiresAuth: true } },
  { path: '/reports', component: 'Reports', meta: { requiresAuth: true } },
  { path: '*', component: 'NotFound'}
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = firebase.auth().currentUser
  if (!requiresAuth) {
    next()
  } else if((isAuthenticated !== null && isAuthenticated !== undefined)){
    if (isAuthenticated.emailVerified){
      next()
    }else{
      next('/login')
    }
  } else {
    next('/login')
  }   
  
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js